import { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

const getDefaultLanguage = () => {
  const browserLang = navigator.language.slice(0, 2);
  return ["en", "es"].includes(browserLang) ? browserLang : "en";
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getDefaultLanguage);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
